import { useCallback, useEffect, useRef, useState } from "react";
import { copyText, locationLink } from "../utils/locationLink";

// La confirmación vive en el mismo botón ("Copiada" con palomita) y no en un
// toast: queda donde está mirando quien hizo clic, que es lo que pidió el
// público de la plataforma (usuarios mayores). 1.8 s alcanza para leerla sin
// que el botón se quede "atorado" si se vuelve a usar.
const FEEDBACK_MS = 1800;

export function useCopyLocation(lat: unknown, lng: unknown) {
  const [state, setState] = useState<"idle" | "copied" | "failed">("idle");
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const link = locationLink(lat, lng);

  useEffect(() => () => {
    if (timer.current) clearTimeout(timer.current);
  }, []);

  const copy = useCallback(async () => {
    if (!link) return;
    const ok = await copyText(link);
    setState(ok ? "copied" : "failed");
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setState("idle"), FEEDBACK_MS);
  }, [link]);

  return { copy, state, available: !!link };
}
